<template>
  <div>

    <div style="display: flex;">

      <div id="left-menu" class="content-son-box" style="width: 190px;margin-right: 10px;height: 100%;position: relative;top: 0px;">
        <div @click="back()"
          style="height: 30px;display: flex;align-items: center;font-weight: 600;cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
              d="M8.45728 2.66904C8.60418 2.52192 8.71467 2.35638 8.78794 2.17243C8.86161 1.9887 8.89844 1.79936 8.89844 1.60507C8.89844 1.41056 8.86161 1.21875 8.78794 1.02961C8.71428 0.840481 8.6042 0.672482 8.45728 0.525345C8.16262 0.231105 7.81085 0.0839844 7.40073 0.0839844C6.99145 0.0839844 6.63885 0.231105 6.34502 0.525345L0.497413 6.42033C0.350088 6.54656 0.24498 6.70671 0.182055 6.90122C0.118738 7.09554 0.0926619 7.29791 0.103433 7.50792C0.113354 7.71815 0.160955 7.92549 0.244964 8.13034C0.328972 8.33561 0.444426 8.51151 0.591766 8.65841L6.34502 14.4588C6.63926 14.7638 6.99145 14.9161 7.40073 14.9161C7.81087 14.9161 8.16263 14.7638 8.45728 14.4588C8.60418 14.3119 8.71467 14.1464 8.78794 13.9626C8.86161 13.7789 8.89844 13.5893 8.89844 13.3952C8.89844 13.2007 8.86161 13.0087 8.78794 12.82C8.71467 12.6309 8.6042 12.4625 8.45728 12.3151L3.69684 7.49217L8.45728 2.66904Z"
              fill="#EA3928" />
          </svg>
          <span style="margin-left: 10px;">返回</span>
        </div>
        <div style="padding: 10px 0 10px 20px;font-size: 17px;">
          <!--            <div style="margin-bottom: 10px;">目录</div>-->
          <div>
            <div style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" href="#box-0">财务比率</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-0')">财务比率</div>
            </div>
          </div>
          <div>
            <div style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" href="#box-1">主营业务</a> -->
              <div style="cursor: pointer;color: #222;" @click="moveToId('#box-1')">主营业务</div>
            </div>
          </div>
        </div>
      </div>

      <div style="width: 1000px;">



        <div class="content-son-box" id="box-0">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">财务比率</span>
          </div>
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="margin-right: 7px;font-size: 16px;font-weight: 600;">{{ industryStandards + ': ' }}</div>
            <div style="margin-right: 7px;font-size: 16px;font-weight: 600;color: #005ab8;">{{ industryName }}</div>
            <div style="font-size: 16px;font-weight: 600;">{{ ' (' + industryNum + ')' }}</div>
            <div style="flex: 1;"></div>
            <div>
              <el-dropdown trigger="click" @command="changeReport">
                <span class="el-dropdown-link" style="cursor: pointer;color: #EA3928;">
                  {{ checkYear + '年' + checkStage }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="(item, index) in reportList" :key="index" :command="item">{{
                    item.year + '年' + item.stage }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div v-if="listDataFinance != null && listDataFinance[financeNames[selectedIndex]] != undefined">
            <div style="display: flex;margin-bottom: 10px;">
              <template v-for="(item, index) in financeNames">
                <div :key="'s-' + index" v-if="selectedIndex == index" class="normal-button-selected">{{ item }}</div>
                <div :key="'n-' + index" v-else class="normal-button" @click="changeSelect(index)">{{ item }}</div>
              </template>
            </div>
            <div class="data-row" style="margin-top: 5px;">
              <div style="width: 40px;">{{ listDataFinance[financeNames[selectedIndex]].median.ranking }}</div>
              <div style="width: 10px;"></div>
              <div style="width: 150px;">{{ listDataFinance[financeNames[selectedIndex]].median.codeName }}</div>
              <div style="width: 10px;"></div>
              <div style="flex: 1;">
                <div style="width: 100%;height: 15px;background-color: #C8C8C8;border-radius: 8px;">
                  <div v-if="listDataFinance[financeNames[selectedIndex]].median.length > 0"
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': '#EA3928', 'width': 'calc(' + listDataFinance[financeNames[selectedIndex]].median.length / 1.2 + '% + 8px)' }">
                  </div>
                  <div v-else-if="listDataFinance[financeNames[selectedIndex]].median.length < 0"
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': 'green', 'width': 'calc(' + (listDataFinance[financeNames[selectedIndex]].median.length * -1) / 1.2 + '% + 8px)' }">
                  </div>
                  <div v-else
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': 'green', 'width': '0px' }">
                  </div>
                </div>
              </div>
              <div style="width: 10px;"></div>
              <div style="width: 150px;">{{ listDataFinance[financeNames[selectedIndex]].median.value }}</div>
            </div>
            <div class="data-row">
              <div style="width: 40px;color: #EA3928;">{{ listDataFinance[financeNames[selectedIndex]].ourCompany.ranking
              }}</div>
              <div style="width: 10px;"></div>
              <div style="width: 150px;">{{ listDataFinance[financeNames[selectedIndex]].ourCompany.codeName }}</div>
              <div style="width: 10px;"></div>
              <div style="flex: 1;">
                <div style="width: 100%;height: 15px;background-color: #C8C8C8;border-radius: 8px;">
                  <div v-if="listDataFinance[financeNames[selectedIndex]].ourCompany.length > 0"
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': '#EA3928', 'width': 'calc(' + listDataFinance[financeNames[selectedIndex]].ourCompany.length / 1.2 + '% + 8px)' }">
                  </div>
                  <div v-else-if="listDataFinance[financeNames[selectedIndex]].ourCompany.length < 0"
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': 'green', 'width': 'calc(' + (listDataFinance[financeNames[selectedIndex]].ourCompany.length * -1) / 1.2 + '% + 8px)' }">
                  </div>
                  <div v-else
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': 'green', 'width': '0px' }">
                  </div>
                </div>
              </div>
              <div style="width: 10px;"></div>
              <div style="width: 150px;">{{ listDataFinance[financeNames[selectedIndex]].ourCompany.value }}</div>
            </div>
            <div class="data-row" v-for="(item, index) in listDataFinance[financeNames[selectedIndex]].allROW"
              :key="index">
              <div style="width: 40px;">{{ item.ranking }}</div>
              <div style="width: 10px;"></div>
              <div style="width: 150px;">{{ item.codeName }}</div>
              <div style="width: 10px;"></div>
              <div style="flex: 1;">
                <div style="width: 100%;height: 15px;background-color: #C8C8C8;border-radius: 8px;">
                  <div v-if="item.length > 0"
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': '#EA3928', 'width': 'calc(' + item.length / 1.2 + '% + 8px)' }">
                  </div>
                  <div v-else-if="item.length < 0"
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': 'green', 'width': 'calc(' + (item.length * -1) / 1.2 + '% + 8px)' }">
                  </div>
                  <div v-else
                    :style="{ 'border-radius': '8px', 'height': '15px', 'background-color': 'green', 'width': '0px' }">
                  </div>
                </div>
              </div>
              <div style="width: 10px;"></div>
              <div style="width: 150px;">{{ item.value }}</div>
            </div>
          </div>
          <div v-else>
            <div style="height: 60px;text-align: center;">
              <div style="font-size: 22px;color: #999999;font-weight: 700;line-height: 60px;">暂无数据</div>
            </div>
          </div>

        </div>

        <div class="content-son-box" id="box-1">
          <div style="display: flex;align-items: center;margin-bottom: 10px;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">主营业务</span>
          </div>
          <div>
            <div v-for="(item, index) in listDataBusiness" :key="index">

              <div v-if="item.type == 1" style="margin-bottom: 8px;">
                <div v-if="item.data.style == 'H1'" style="font-size: 19px;font-weight:700;text-align: center;">{{
                  item.data.strings }}</div>
                <div v-else-if="item.data.style == 'H2'" style="font-size: 18px;font-weight:700;">{{ item.data.strings }}
                </div>
                <div v-else-if="item.data.style == 'H3'" style="font-size: 17px;font-weight:700;">{{ item.data.strings }}
                </div>
                <div v-else style="font-size: 16px;">{{ item.data.strings }}</div>
              </div>

              <div v-if="item.type == 2">
                <div style="font-size: 13px;color: #666;text-align: center;">{{ item.data.name }}</div>
                <table cellspacing="0">
                  <thead>
                    <tr>
                      <th v-for="(head, index2) in item.data.head" :key="index2">{{ head }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(body, index2) in item.data.body" :key="index2">
                      <td v-for="(bodyItem, index3) in body" :key="index3">{{ bodyItem }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div v-if="item.type == 3">
                <div style="display: none;">{{ drawECharts('echarts-' + index, item.data) }}</div>
                <div :id="'echarts-' + index" style="width: 100%;height: 300px;"></div>
              </div>

              <div v-if="item.type == 4 || item.type == 5">
                <div style="margin-bottom: 10px;">
                  <div style="display: flex;border: 1px solid #EA3928;width: max-content;margin: 0 auto;">
                    <!-- 初始化 -->
                    <div style="display: none;">
                      {{ selectedIndex2['echarts-' + index] == undefined ? $set(selectedIndex2, 'echarts-' + index, 0) :
                        null }}
                      {{ changeChartSelect(selectedIndex2['echarts-' + index], 'echarts-' + index,
                        item.data.chartDataList[selectedIndex2['echarts-' + index]], null) }}
                    </div>
                    <template v-for="(item2, index2) in item.data.chartNameList">
                      <div :key="'s-' + index2" v-if="selectedIndex2['echarts-' + index] == index2"
                        class="normal-box-selected">
                        {{ item2 }}</div>
                      <div :key="'n-' + index2" v-else class="normal-box"
                        @click="changeChartSelect(index2, 'echarts-' + index, item.data.chartDataList[index2], null)">{{
                          item2 }}</div>
                    </template>
                  </div>
                  <div class="showInfo">
                    <div :id="'echarts-' + index + '-' + index2" style="width: 100%;height: 300px;"></div>
                  </div>
                </div>
              </div>

              <div v-if="item.type == 10">
                <img style="width: 90%;" :src="'data:image/png;base64,' + item.data">
              </div>

              <div v-if="item.type == 20">

                <div v-if="item.data.chartAnalysis[0][0].type == 24">

                  <div style="display: none">
                    {{ selectedIndex2['tables-' + index] == undefined ? $set(selectedIndex2, 'tables-' + index + '-' +
                      index, 0) :
                      null }}
                  </div>
                  <div style="overflow-x: auto;margin-bottom: 5px;">
                    <div :style="{ height: '36px', width: 120 * item.data.chartAnalysis.length + 'px' }"
                      v-if="item.data.chartAnalysis.length > 1">
                      <div style="display: inline-block;margin-right: 10px;"
                        v-for="(item2, index2) in item.data.chartNames" :key="index2">
                        <div style="width: 90px;" v-if="selectedIndex2['tables-' + index] == index2"
                          class="normal-button-selected">{{ item2 }}</div>
                        <div style="width: 90px;" v-else class="normal-button"
                          @click="changeChartSelect(index2, 'tables-' + index)">{{ item2 }}</div>
                      </div>
                    </div>
                  </div>
                  <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;"
                    v-if="item.data.chartAnalysis != null">
                    <table cellspacing="0" style="width: auto;min-width: 100%;">
                      <thead>
                        <tr>
                          <th style="min-width: 100px;"
                            v-for="(head, index2) in item.data.chartAnalysis[selectedIndex2['tables-' + index]][0].data.head"
                            :key="index2">{{ head }}</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="(body, index2) in item.data.chartAnalysis[selectedIndex2['tables-' + index]][0].data.body"
                          :key="index2">
                          <td v-for="(bodyItem, index3) in body" :key="index3">{{ bodyItem }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                </div>
                <div v-else>
                  <div v-for="(item2, index2) in item.data.chartAnalysis" :key="index2">
                    <div v-for="(item3, index3) in item2" :key="index3">

                      <div v-if="item3.type == 1" :class="item3.data.style" style="margin-bottom: 10px;">
                        <div v-if="item3.data.style == 'H2'">· {{ item3.data.strings }}</div>
                        <div v-else v-html="item3.data.strings.replaceAll('\n', '<br>')"></div>
                      </div>

                      <div v-if="item3.type == 4">
                        <div style="margin-bottom: 10px;">
                          <div style="display: flex;border: 1px solid #EA3928;width: max-content;margin: 0 auto;">
                            <!-- 初始化 -->
                            <div style="display: none;">
                              {{ selectedIndex2['echarts-' + index + '-' + index2 + '-' + index3] == undefined ?
                                $set(selectedIndex2,
                                  'echarts-' + index + '-' + index2 + '-' + index3, 0) : null }}
                              {{ changeChartSelect(selectedIndex2['echarts-' + index + '-' + index2 + '-' + index3],
                                'echarts-' + index + '-' + index2 + '-' + index3,
                                item3.data.chartDataList[selectedIndex2['echarts-' + index + '-' + index2 + '-' + index3]],
                                item3.data.tableList[selectedIndex2['echarts-' + index + '-' + index2 + '-' + index3]]) }}
                            </div>
                            <template v-for="(item4, index4) in item3.data.chartNameList">
                              <div :key="'s-' + index4"
                                v-if="selectedIndex2['echarts-' + index + '-' + index2 + '-' + index3] == index4"
                                class="normal-box-selected">{{ item4 }}</div>
                              <div :key="'n-' + index4" v-else class="normal-box"
                                @click="changeChartSelect(index4, 'echarts-' + index + '-' + index2 + '-' + index3, item3.data.chartDataList[index4], item3.data.tableList[index4])">
                                {{ item4 }}</div>
                            </template>
                          </div>
                          <div class="showInfo">
                            <div :id="'echarts-' + index + '-' + index2 + '-' + index3"
                              style="width: 100%;height: 300px;"></div>
                          </div>
                          <div style="overflow-x: auto;overflow-y: auto;max-height: 500px;">
                            <table cellspacing="0" style="width: auto;min-width: 100%;">
                              <thead>
                                <tr>
                                  <th
                                    v-for="(head, index4) in chartTableData['echarts-' + index + '-' + index2 + '-' + index3].head"
                                    :key="index4">{{ head }}</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr
                                  v-for="(body, index4) in chartTableData['echarts-' + index + '-' + index2 + '-' + index3].body"
                                  :key="index4">
                                  <td v-for="(bodyItem, index6) in body" :key="index6">{{ bodyItem }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </div>
                      </div>

                      <div v-if="item3.type == 21">
                        <div v-for="(item4, index4) in item3.data" :key="index4"
                          style="display: flex;margin-bottom: 10px;padding-bottom: 10px;border-bottom: 1px solid #dedede;">
                          <div style="width: 150px;color: #333;">
                            {{ item4.firstColumnValue }}
                          </div>
                          <div style="flex: 1;">
                            {{ item4.seconColumnValue }}
                          </div>
                        </div>
                      </div>

                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>

        </div>

      </div>

    </div>

  </div>
</template>
    
<script>
import * as echarts from "echarts";
import { linkName, sendRequestIndustry } from '../../../../static/js/util';

export default {
  data() {
    return {
      comCode: '',
      name: '',

      checkYear: '',
      checkStage: '',
      reportList: [],

      industryStandards: '--',
      industryNum: '--',
      industryName: '----',
      selectedIndex: 0,
      selectedName: '',

      financeNames: [],
      listDataFinance: [],

      listDataBusiness: [],
      selectedIndex2: {},
      chartTableData2: {}
    };
  },
  mounted() {
    this.comCode = this.$route.query.comCode;
    this.name = this.$route.query.comName;

    window.parent.onscroll = () => {
      var scrollHeight = window.parent.scrollY;
      if (scrollHeight > 100) {
        $('#left-menu').css({ top: scrollHeight - 100 + 'px' });
      } else {
        $('#left-menu').css({ top: '0px' });
      }
    }

    this.getData1();
    this.getData2();
  },
  methods: {
    back() {
      linkName(this, 'companyResearch');
    },
    moveToId(idStr) {
      document.querySelector(idStr).scrollIntoView({
        behavior: "smooth"
     });
    },
    getData1() {
      let url = '/company/selfOneComNew?code=' + this.comCode;
      sendRequestIndustry(url, 'get', null, response => {
        // console.log(response.data)
        if (response.data.code === 0) {
          this.reportList = response.data.data.comInfoDTO.comReports;
          this.checkYear = response.data.data.year;
          this.checkStage = response.data.data.stage;

          this.getListDataFinance(response.data.data.year, response.data.data.stage);

        }
        // else if(response.data.code === 1){
        //     this.$alert(response.data.msg, '提示', {
        //         confirmButtonText: '确定',
        //         callback: action => {
        //             //window.history.back();
        //         }
        //     });
        // }else{
        //     this.$alert('分析报告未出', '提示', {
        //         confirmButtonText: '确定',
        //         callback: action => {
        //             //window.history.back();
        //         }
        //     });
        // }
      }, error => {
        console.log(error);
      })
    },
    getListDataFinance(year, stage) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      let type = (stage == '年报' ? 0 : stage == '一季报' ? 1 : stage == '中报' ? 2 : 3)
      let url = '/getIndexRanking?code=' + this.comCode + '&year=' + year + '&type=' + type;
      sendRequestIndustry(url, 'get', null, response => {
        loading.close();
        if (response.data.flag === true) {
          this.industryName = response.data.industryName;
          this.industryNum = response.data.enterpriseNumber;
          this.industryStandards = response.data.standard;
          this.financeNames = response.data.tabulation;
          this.listDataFinance = response.data.data;
        } else {
          this.listDataFinance = null;
        }
      }, error => {
        loading.close();
        console.log(error);
      })


    },
    getData2() {
      let url = '/company/industryResult/' + this.comCode + '/' + 2022 + '/' + '年报';
      sendRequestIndustry(url, 'get', null, response => {
        // console.log(response.data)
        if (response.data.code === 0) {
          this.listDataBusiness = response.data.data;
        }
      }, error => {
        console.log(error);
      })
    },
    changeSelect(sign) {
      this.selectedIndex = sign;
    },
    changeReport(row) {
      this.checkYear = row.year;
      this.checkStage = row.stage;

      this.getListDataFinance(this.checkYear, this.checkStage);
    },
    changeChartSelect(sign, idStr, echartsData, tableData) {
      // this.selectedIndex[idStr] = sign;//页面不刷新
      // Vue.set(this.selectedIndex, idStr, sign);//动态添加能刷新
      this.$set(this.selectedIndex2, idStr, sign);//动态添加能刷新

      if (echartsData != undefined && echartsData != null) {
        //清除echarts图
        // $('.showInfo div[_echarts_instance_]').html("");
        // $('.showInfo div[_echarts_instance_]').removeAttr("_echarts_instance_");
        // var dom = $('#' + idStr);
        // dom.html("");
        // dom.removeAttr("_echarts_instance_");

        this.drawECharts(idStr, echartsData);
      }
      // this.chartTableData[idStr] = tableData;
      // Vue.set(this.chartTableData, idStr, tableData);
      if (tableData != undefined && tableData != null) {
        this.$set(this.chartTableData2, idStr, tableData);
      }

    },
    //画echarts图
    drawECharts(idName, data) {
      setTimeout(() => {
        // console.log(idName)
        var chartDom = document.getElementById(idName);
        var myChart = echarts.init(chartDom);
        var option = JSON.parse(data);
        option && myChart.setOption(option);
      }, 300)
    },
  }
};
</script>
    
<style scoped>
.normal-button {
  background-color: #F0F2F4;
  color: #000;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 5px;
}

.normal-button-selected {
  background-color: #f6e2e3;
  color: #EA3928;
  padding: 7px 10px;
  border-radius: 5px;
  margin-right: 5px;
}

.normal-box {
  background-color: #fff;
  color: #999;
  padding: 4px 20px;
  cursor: pointer;
}

.normal-box-selected {
  background-color: #EA3928;
  color: #fff;
  padding: 4px 20px;
}

.data-row {
  display: flex;
  align-items: center;
  text-align: center;
  padding: 7px 0;
}

.data-row:hover {
  background-color: #e1e1e1;
}

.content-son-box {
  margin-top: 30px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}
</style>